<!--真伪查询页面-->
<template>
  <div class="sales-home-container">
  <div class="container">
    <div class="title">真伪查询</div>
    <el-form class="form-inline">
      <!-- 球杆编号 -->
      <el-form-item label="球杆编号：" prop="number">
        <el-input
            type="text"
            v-model="formData.number"
            placeholder="请选择球杆编号"
            @keydown.prevent
            @click.native="openSelectDialog()"
            readonly
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="s-banner">
      <img :src="src" alt="" class="img_item" />
    </div>
    <div class="btn-group">
      <el-button type="primary" @click="search">查询</el-button>
    </div>
    <div class="btn-group-back">
      <el-button type="default" @click="goHome">返回首页</el-button>
    </div>
    <el-footer class="s-footer">
      <p>JING-DIAN BILLIARD CLUB AFTER SALES</p>
    </el-footer>

    <!-- 调用提示语弹框组件 -->
    <MessageDialog
        v-if="showDialog"
        title="提示"
        :content="messageContent"
        confirmText="我知道了"
        :showCancel="false"
        @confirm="showDialog = false"
        @close="showDialog = false"
        closeOnMask
    />
  </div>
    <!-- 引入自定义select组件 -->
    <SelectDialog
        :visible="selectDialogVisible"
        :options="selectOptions"
        :active-value="formData.number"
        @select="handleSelect"
        @close="selectDialogVisible = false"
    />
  </div>
</template>

<script>
import {getImgList} from "@/api/home";
import MessageDialog from "@/views/business/utils/messageDialog.vue";
import {checkPortal, productByUser} from "@/api/sales";
import SelectDialog from "@/views/business/utils/selectDialog.vue";
import {ImageTypeEnum} from "@/enums/imageTypeEnum";

export default {

  components: {
    SelectDialog,
    //消息提示组件 可以是纯文字 也可以是html格式
    MessageDialog: MessageDialog
  },

  data() {
    return {
      // 表单数据（双向绑定）
      formData: {
        number: ''
      },
      //图片路径
      src:'',
      imgList: [],
      //提示信息提示弹框组件是否显示
      showDialog: false,
      //提示信息内容
      messageContent:'',

      //select弹框组件
      selectDialogVisible: false,

      selectOptions: [],
    }
  },

  created() {
    this.getBannerList();
  },
  methods: {
    //获取当前登录人名下注册登记的球杆
    openSelectDialog(){
      productByUser().then(res => {
        if (res.code === 200) {
          this.selectOptions = res.data;
          this.selectDialogVisible = true; // 打开弹框
        } else {
          this.showDialog = true;
          this.messageContent = res.returnMsg;
        }
      })
    },

    //获取当前登录人名下注册登记的球杆
    handleSelect(item) {
      this.formData.number = item.value; // 赋值到对应行
      this.selectDialogVisible = false; // 关闭弹框
      this.selectOptions = [];
    },

    //获取背景图
    getBannerList() {
      // 调用后端接口
      let slideId = ImageTypeEnum.SALES_SEARCH.value;
      getImgList(slideId).then(res => {
        const dataList = res.data;
        this.src = dataList[0].src;
      }
      )
    },
    // 返回首页
    goHome() {
      // 实际项目可替换为Vue Router跳转：this.$router.push('/')
      this.$router.replace('/sales_home');
    },
    // 真伪查询
    search(){
      if(this.formData.number == ''){
        this.showDialog = true;
        let  msgStr = `请输入球杆编号`;
        this.messageContent = msgStr;
        return false;
      }
      //球杆编号
      let keyWord = this.formData.number;
      //查询真伪接口
      checkPortal(keyWord).then(res => {
        if(res.code==200){
          const data = res.data;
          const code = data.code
          let msgStr = "";
          if(code == 5){
            msgStr = `<p>此杆号已失效，假货和克隆号可能性极大，请联系官方售后电话或找附近经销商确认.</p>
                                <p>球杆售后咨询：<a href="tel:18603360681">18603360681</a></p>
                            `;
            //提示信息提示弹框组件是否显示
            this.showDialog = true;
            //提示信息内容
            this.messageContent = msgStr;
            return false;
          } else if(code ==0) {
            this.showDialog = true;
            this.messageContent =data.returnMsg;
            return false;
          } else if(code == 2) {
            msgStr = `<p>很遗憾，您所查询的杆号非璟点公司提供正品行货，没有售后保障。请联系官方售后电话或找附近经销商确认。</p>
                                <p>球杆售后咨询：<a href="tel:18603360681">18603360681</a></p>
                            `;
            this.showDialog = true;
            this.messageContent = msgStr;
            return false;
          } else{
            if(code == 1) {
              if(data.check_number > 5) {
                msgStr = `<p>此杆号已失效，假货和克隆号可能性极大，请联系官方售后电话或找附近经销商确认</p>
                                <p>球杆售后咨询：<a href="tel:18603360681">18603360681</a></p>`;
                this.showDialog = true;
                this.messageContent = msgStr;
                return false;
              }else{
                let agent_name = "";
                if(data.agent_name != '' && data.agent_name != null){
                  agent_name = "，授权销售商为”"+data.agent_name+"“。";
                }
                msgStr = `
                                    <p>恭喜您！该编号[${data.portal_number}]商品为正品，请您放心使用。</p>
                                    <p>${data.portalspecs?'该编号商品为['+data.portalspecs+']':''}</p>
                                    <p>该编号商品出货日期为[${data.create_time}]${agent_name}
                                    <p>该编号商品已查询[${data.check_number}]次</p>
                                    <p>上次查询时间[${data.cx_time}]</p>
                                `;
                this.showDialog = true;
                this.messageContent = msgStr;
              }
            }
          }
        }
      })
    }
  }
}
</script>

<style lang="scss">
// 全局容器样式
.sales-home-container {
  width: 100%;
  min-height: 100vh;
  background: #efefef;

  .container {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;

    .el-form-item {
      margin: 0;
    }
    // ===================== 移动端适配（<768px） =====================
    @media screen and (max-width: 768px) {
      //底部按钮
      .btn-group {
        display: flex;
        justify-content: center;
        gap: 15px;
        margin-top: 30px;
        height: 50px;
        line-height: 50px;
        font-size: 26px;
      }
      .btn-group-back {
        display: flex;
        justify-content: center;
        gap: 15px;
        height: 50px;
        line-height: 50px;
        margin: 20px 0 30px 0;
      }
      .el-button--primary {
        font-size: 20px;
        color: #0f0f0f;
        background: #f6c27a;
        border: none;
        width: 80%;
        border-radius: 3px;
      }

      .el-button--default {
        font-size: 20px;
        color: #0f0f0f;
        background: #dcdcdc;
        border: none;
        width: 80%;
        border-radius: 3px;
      }


      //表单相关
      .form-inline {
        padding: 10px 0;
      }

      .el-form-item {
        background: #FFFFFF;
        height: 50px;
        padding: 0 10px;
      }
      /* 修改Label样式：字体大小、宽度、对齐方式 */
      .el-form-item__label {
        font-weight: 500;
        font-size: 16px !important; /* Label字体大小（默认14px） */
        text-align: left !important;
        line-height: 50px;
      }
      .el-form-item__content {
        line-height: 50px;
        padding-left: 90px;
      }

      /* 统一控件高度和字体大小 */
      .el-input__inner,
      .el-select-dropdown__item,
      .el-date-picker__header,
      .el-date-picker__cell {
        font-size: 16px !important; /* 控件内文本大小（默认14px） */
        height: 50px !important; /* 控件高度（默认36px） */
        line-height: 50px !important; /* 行高与高度一致，垂直居中 */
        border: none;
      }

      //顶部标题
      .title {
        text-align: center;
        line-height: 60px;
        font-size: 16px;
        color: #161616;
        letter-spacing: 1px;
        background: #f6c27a;
        font-weight: bold;
      }
      .input {
        height: 50px;
        background: #FFFFFF;
        padding: 5px 0;
      }
      .s-banner {
        .img_item {
          height: 100%;
          width: 100%;
        }
      }
      //页脚
      .s-footer {
        height: 50px;
        background: #2c2c2c;
        display: flex;
        justify-content: center; /* 水平居中（主轴对齐） */
        align-items: center; /* 垂直居中（交叉轴对齐） */
        p {
          color: #ea9538;
          font-size: 10px;
          font-weight: bold;
          letter-spacing: 1px;
        }
      }
    }


    // ===================== 平板适配（768px ≤ 宽度 < 1200px） =====================
    @media screen and (min-width: 768px) and (max-width: 1199px) {
      max-width: 900px;
      margin: 0 auto !important;
      padding: 0 20px;
      //底部按钮
      .btn-group {
        display: flex;
        justify-content: center;
        gap: 15px;
        margin-top: 30px;
        height: 50px;
        line-height: 50px;
        font-size: 26px;
      }
      .btn-group-back {
        display: flex;
        justify-content: center;
        gap: 15px;
        height: 50px;
        line-height: 50px;
        margin: 20px 0 30px 0;
      }
      .el-button--primary {
        font-size: 20px;
        color: #0f0f0f;
        background: #f6c27a;
        border: none;
        width: 80%;
        border-radius: 3px;
      }

      .el-button--default {
        font-size: 20px;
        color: #0f0f0f;
        background: #dcdcdc;
        border: none;
        width: 80%;
        border-radius: 3px;
      }


      //表单相关
      .form-inline {
        padding: 10px 0;
      }

      .el-form-item {
        background: #FFFFFF;
        height: 50px;
        padding: 0 10px;
      }
      /* 修改Label样式：字体大小、宽度、对齐方式 */
      .el-form-item__label {
        font-weight: 500;
        font-size: 16px !important; /* Label字体大小（默认14px） */
        text-align: left !important;
        line-height: 50px;
      }
      .el-form-item__content {
        line-height: 50px;
        padding-left: 100px;
      }

      /* 统一控件高度和字体大小 */
      .el-input__inner,
      .el-select-dropdown__item,
      .el-date-picker__header,
      .el-date-picker__cell {
        font-size: 16px !important; /* 控件内文本大小（默认14px） */
        height: 50px !important; /* 控件高度（默认36px） */
        line-height: 50px !important; /* 行高与高度一致，垂直居中 */
        border: none;
      }

      //顶部标题
      .title {
        text-align: center;
        line-height: 60px;
        font-size: 16px;
        color: #161616;
        letter-spacing: 1px;
        background: #f6c27a;
        font-weight: bold;
      }
      .input {
        height: 50px;
        background: #FFFFFF;
        padding: 5px 0;
      }
      .s-banner {
        .img_item {
          height: 100%;
          width: 100%;
        }
      }
      //页脚
      .s-footer {
        height: 50px;
        background: #2c2c2c;
        display: flex;
        justify-content: center; /* 水平居中（主轴对齐） */
        align-items: center; /* 垂直居中（交叉轴对齐） */
        p {
          color: #ea9538;
          font-size: 10px;
          font-weight: bold;
          letter-spacing: 1px;
        }
      }
    }

    // ===================== PC端适配（≥1200px） =====================
    @media screen and (min-width: 1200px) {
      max-width: 1200px;
      margin: 0 auto !important;
      padding: 0 20px;
      //底部按钮
      .btn-group {
        display: flex;
        justify-content: center;
        gap: 15px;
        margin-top: 30px;
        height: 50px;
        line-height: 50px;
        font-size: 26px;
      }
      .btn-group-back {
        display: flex;
        justify-content: center;
        gap: 15px;
        height: 50px;
        line-height: 50px;
        margin: 20px 0 30px 0;
      }
      .el-button--primary {
        font-size: 20px;
        color: #0f0f0f;
        background: #f6c27a;
        border: none;
        width: 80%;
        border-radius: 3px;
      }

      .el-button--default {
        font-size: 20px;
        color: #0f0f0f;
        background: #dcdcdc;
        border: none;
        width: 80%;
        border-radius: 3px;
      }


      //表单相关
      .form-inline {
        padding: 10px 0;
      }

      .el-form-item {
        background: #FFFFFF;
        height: 50px;
        padding: 0 10px;
      }
      /* 修改Label样式：字体大小、宽度、对齐方式 */
      .el-form-item__label {
        font-weight: 500;
        font-size: 16px !important; /* Label字体大小（默认14px） */
        text-align: left !important;
        line-height: 50px;
      }
      .el-form-item__content {
        line-height: 50px;
        padding-left: 100px;
      }

      /* 统一控件高度和字体大小 */
      .el-input__inner,
      .el-select-dropdown__item,
      .el-date-picker__header,
      .el-date-picker__cell {
        font-size: 16px !important; /* 控件内文本大小（默认14px） */
        height: 50px !important; /* 控件高度（默认36px） */
        line-height: 50px !important; /* 行高与高度一致，垂直居中 */
        border: none;
      }

      //顶部标题
      .title {
        text-align: center;
        line-height: 60px;
        font-size: 16px;
        color: #161616;
        letter-spacing: 1px;
        background: #f6c27a;
        font-weight: bold;
      }
      .input {
        height: 50px;
        background: #FFFFFF;
        padding: 5px 0;
      }
      .s-banner {
        .img_item {
          height: 100%;
          width: 100%;
        }
      }
      //页脚
      .s-footer {
        height: 50px;
        background: #2c2c2c;
        display: flex;
        justify-content: center; /* 水平居中（主轴对齐） */
        align-items: center; /* 垂直居中（交叉轴对齐） */
        p {
          color: #ea9538;
          font-size: 10px;
          font-weight: bold;
          letter-spacing: 1px;
        }
      }
    }
  }
}
</style>